import { type MaybeRef, toValue } from 'vue';

import { getAccountLimits, getTeamLimits } from './api';
import { limitsKeys } from './keys';

export const limitsQueryOptions = (teamUuid?: MaybeRef<string | undefined>) => ({
  queryKey: limitsKeys.limits(teamUuid),
  queryFn: () => {
    const uuid = toValue(teamUuid);
    return uuid ? getTeamLimits(uuid) : getAccountLimits();
  },
});
